import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionAccessibility = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"type": "page",
			"properties": {
				"title": [
					[
						"Доступность"
					]
				]
			},
			"content": [
				"95970456-2bf7-4f21-a6c7-21e3b68f9b7d",
				"3ce96a88-182b-4503-b2a7-6b546f45000e",
				"493447ef-9ab1-4d51-8639-f253d381c4ac",
				"a0d89741-c885-4529-9520-008f7131faab",
				"ce637723-b3ac-4ce5-b476-db1dcdff07bf",
				"d3b9267d-febb-4d9a-9650-fdc7d072bb55",
				"c097dfd5-5f1d-4c8b-b12c-b67d35c907ad",
				"be44413e-288b-4f04-84f0-6517e136bf4e",
				"7cdc7a1f-07b7-4091-8145-ecf29e2bd537",
				"0eff6331-5eb8-4cfb-8cf0-f08aab3f7b98",
				"6056fae5-263a-491e-a408-9cc5f9550953",
				"575d1f7a-998c-4de7-9556-effab06e85ca",
				"515687a0-1441-4212-a6ed-71a3e921048f",
				"7c1a2f33-00d6-4906-9e2b-31439732c823",
				"31ef30b4-844e-4f8b-bf35-3604b3edf57f",
				"7e413906-ac96-4ff9-aff2-48e60e348587",
				"21276d53-543d-41d3-a821-74892b6cec9a",
				"fdb5d247-c8b6-48cd-83e5-9e4b0ab7edeb",
				"1bd42b00-2b11-4c53-8e0d-ce4896b071ff",
				"fd7aa35a-1860-4801-83d9-11e1c220123f",
				"96f2b009-3cf6-402b-8daa-f66ba96cf08a",
				"daee3611-2bce-4f45-bc09-0487d5b1bf4d",
				"1d09eced-bb8d-4e94-87ef-ab36e4cc12ae",
				"55cc1bf5-f7c5-4762-ac5f-074461df4632",
				"18c8a3e6-6288-4a41-9714-387d3d08882f",
				"7a6fcfcb-1a2d-452f-a31c-ab6f5e2ae021",
				"83bc4b03-2659-4831-937b-865e045ae664",
				"310bd1af-ec4b-4816-bf67-1eb88622abf1",
				"428a2e41-1587-4604-85d0-3aca0735b0c3",
				"d6761429-81a3-4a99-b5ee-d29eed8390bb",
				"25bcc38a-d74c-4034-a3b7-b9237c2e7fdb",
				"a2888952-14e9-476a-ba64-1e4ad7779a16",
				"05b9f6d0-37e4-4d14-abc2-b2301f55b96c",
				"3d30dc4f-a467-4103-b329-2793a6df1c5d",
				"a41b8223-82a1-4fa5-be10-5eba8a22df32",
				"bec61e00-f2fd-4589-a965-1fed727820f8",
				"2a87b7dd-f5b5-4f16-867b-d772afb4d3ac",
				"1b96918c-9284-4767-a862-4432a01aef9d",
				"1a494066-e050-4086-90e8-3a8d3a0cfab1",
				"065b8a26-355b-462f-b90b-23e395671368",
				"539c2adf-4da3-44c5-be93-2ee7a4696aa0",
				"612404d5-c308-4f87-a781-e2254813dd80",
				"2e241594-59da-4a83-87a6-83337df79b99",
				"4a8dc47b-c220-41ec-bbe1-1f01c01ac7ea",
				"fc1cb1ec-355c-44ba-9806-4e9c285ab16a",
				"bf3b4f54-6413-4d50-ac2e-916e477ba8c5",
				"6fa063ff-a7a3-48a8-84d9-4d56088075f2",
				"9341e0da-b13c-45ad-968a-c7a9a7bba9db",
				"7034aece-d906-4644-ac9c-52c0df5dfd4e",
				"c21d76e8-eeb9-43f3-880e-c93fc05a832a",
				"cb4ba2b7-07fd-4d7d-ad4b-6b0182aaee88",
				"054334c3-f707-4697-91b1-ccd69e1dbe42",
				"b301a268-c1f3-40c9-a600-99098448dc65",
				"9947a597-aa97-4586-9c57-2db989552727",
				"7f75bf12-4e37-4965-952b-fa99538fe887",
				"37e3810e-16cb-43d1-8f3a-c4637e02a4fe",
				"74f1b084-a764-44ab-8138-1e067326ab52",
				"80c028b6-7572-4b76-8cdd-8c28d5bed509",
				"ef6e9d3b-36d8-4d0e-aeb6-3216bed283b1",
				"c3d57d1c-e525-40d0-8b84-b7a25c55df90",
				"44183c3a-4c0b-4f67-98c7-ab2c3e451be2",
				"6d3a5461-5080-4946-a567-e57cc0111e89",
				"2d4c84c1-1365-42bb-8f3e-3a1e0851210d",
				"0be31fb9-1412-47e4-8f0f-e14dfa254038",
				"abe4e7bc-db74-4257-a6fb-7e96d64743d5",
				"aa752c8a-4141-4d70-9db3-aeeb5e102ed4",
				"acdb9319-182d-4fb0-ab04-42ae3c809560",
				"7c3ac514-3a4a-4daa-b557-be77f7a6ee09",
				"e018c766-349f-4983-8bec-33859a82ec06"
			],
			"format": {
				"copied_from_pointer": {
					"id": "f9555a25-defb-4c43-bfc7-344cc0dfd5c4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"8e58b476-b7b6-4ade-bb88-978f04cd832c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "95970456-2bf7-4f21-a6c7-21e3b68f9b7d",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/accessibility\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3ce96a88-182b-4503-b2a7-6b546f45000e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наша миссия — сделать интерфейсы продуктов доступными для максимального количества людей. Поэтому нам важно, чтобы люди с ограниченными возможностями тоже могли пользоваться нашими сервисами. Это и есть доступность."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "76a3c015-59d9-4317-9ba8-e8397b6cf4ae",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "493447ef-9ab1-4d51-8639-f253d381c4ac",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3dcd33c9-5125-492f-ab65-84bfe06f93ba/accessibility.png"
					]
				]
			},
			"format": {
				"block_width": 2184,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3dcd33c9-5125-492f-ab65-84bfe06f93ba/accessibility.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "74e0c979-32c2-4a87-a739-a323d7b7e39b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"file_ids": [
				"3dcd33c9-5125-492f-ab65-84bfe06f93ba"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/493447ef-9ab1-4d51-8639-f253d381c4ac.png"
		},
		{
			"id": "a0d89741-c885-4529-9520-008f7131faab",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Почти в каждом разделе гайдлайна вы найдёте рекомендации по доступности."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "24411db3-b292-4f0a-9d99-3aea5f0f3278",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce637723-b3ac-4ce5-b476-db1dcdff07bf",
			"type": "header",
			"properties": {
				"title": [
					[
						"Как проверяются материалы визуального языка"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f086acd2-8108-47ce-8c7b-b9334246a85d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d3b9267d-febb-4d9a-9650-fdc7d072bb55",
			"type": "text",
			"properties": {
				"title": [
					[
						"Базовые материалы визуального языка — цвета, их сочетания и типографические схемы — должны соответствовать гайдлайнам доступности WCAG и пройти исследование на восприятие в продукте."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3a212a11-2603-4394-becb-7cb13071d907",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c097dfd5-5f1d-4c8b-b12c-b67d35c907ad",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы проверяем базовую распознаваемость элементов визуального языка, но это не значит, что дизайнер может не обращать на это внимание. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bb8e1b5a-a160-456f-8405-9c938fbfe519",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "be44413e-288b-4f04-84f0-6517e136bf4e",
			"type": "toggle",
			"content": [
				"222dc9aa-0867-4a0b-b73a-82dd0688eccc"
			],
			"format": {
				"copied_from_pointer": {
					"id": "3018dab6-ed85-4095-ae82-830dea8995d4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7cdc7a1f-07b7-4091-8145-ecf29e2bd537",
			"type": "column_list",
			"content": [
				"28b470cc-d5dc-4bac-b2e9-42184e6a9aa1",
				"99b6c441-6885-427b-abbc-4311488a29df"
			],
			"format": {
				"copied_from_pointer": {
					"id": "2c4a406f-b995-47ba-8402-2b4c1ed00eb8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0eff6331-5eb8-4cfb-8cf0-f08aab3f7b98",
			"type": "column_list",
			"content": [
				"9e29d934-7a04-4bdd-a929-d5767e33e97d",
				"dba69699-f352-490d-b6da-a8d51b4b9a79"
			],
			"format": {
				"copied_from_pointer": {
					"id": "71484094-a53c-4912-bf5b-d9e5c2c7179c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6056fae5-263a-491e-a408-9cc5f9550953",
			"type": "column_list",
			"content": [
				"a80796c5-7063-4e85-a192-c99ae1415d1a",
				"9a798378-9f34-4cc6-967e-0e683897288c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "34badbe0-0e29-4df3-ac28-d373502db2ac",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "575d1f7a-998c-4de7-9556-effab06e85ca",
			"type": "header",
			"properties": {
				"title": [
					[
						"Структура"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bc45a670-ac6c-4c07-9302-2e60f76e3eee",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "515687a0-1441-4212-a6ed-71a3e921048f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пользователь должен считывать структуру, смысл страницы и ключевые действия на ней. Старайтесь делать дизайн таким, чтобы пользователь легко находил ключевую информацию. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "94cd405c-67c1-46eb-9e26-8630b47869bd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c1a2f33-00d6-4906-9e2b-31439732c823",
			"type": "text",
			"properties": {
				"title": [
					[
						"Содержимое страницы должно вписываться в структуру заголовков. Также у пользователя должна быть и альтернативная навигация: карта сайта, оглавление, меню, поиск и т.п."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "93774db5-8d1e-4946-98e3-f2949870f379",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "31ef30b4-844e-4f8b-bf35-3604b3edf57f",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Обращайте внимание не только на дизайн страницы, но и на разметку для скринридеров."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "c3c09f9c-0109-434d-8a2d-d610176be553",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7e413906-ac96-4ff9-aff2-48e60e348587",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Поддержание структуры информации для скринридера"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2756bc9d-8422-40b2-bd50-04617a543758",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "21276d53-543d-41d3-a821-74892b6cec9a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Порядок считывания скринридера должен совпадать с порядком подачи информации на странице."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "996e36aa-cc76-4593-ab63-0eecf673b6fc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fdb5d247-c8b6-48cd-83e5-9e4b0ab7edeb",
			"type": "column_list",
			"content": [
				"5b79f2f6-02da-4cbd-b826-a9e21dff7b79",
				"48c55243-df9a-4ec9-ab43-840955a377df"
			],
			"format": {
				"copied_from_pointer": {
					"id": "d653a31b-0d40-43da-8d9d-64930d487861",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1bd42b00-2b11-4c53-8e0d-ce4896b071ff",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://material.io/design/usability/accessibility.html"
					]
				],
				"title": [
					[
						"Material Design"
					]
				],
				"caption": [
					[
						"Assistive Technology"
					]
				],
				"description": [
					[
						"Build beautiful, usable products faster. Material Design is an adaptable system-backed by open-source code-that helps teams build high quality digital experiences."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://material.io/static/assets/favicon.ico",
				"copied_from_pointer": {
					"id": "573c2399-a268-4015-95af-d6bd631f4cca",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fd7aa35a-1860-4801-83d9-11e1c220123f",
			"type": "header",
			"properties": {
				"title": [
					[
						"Типографика"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "50a17f4c-f4d9-4e93-9dab-94db7f5e6e11",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "96f2b009-3cf6-402b-8daa-f66ba96cf08a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Работая с типографикой, отталкивайтесь не только от правил читабельности, но и характеристик конкретного шрифта. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1b7fbfe0-e5ae-4de2-b055-10c76875aefc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "daee3611-2bce-4f45-bc09-0487d5b1bf4d",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Убедитесь, что пользователю не нужно прикладывать усилия для чтения текста на странице. В этом вам помогут оптимальные параметры типографики."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "4419df4c-c3a1-4524-98df-d09ef5586ec4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1d09eced-bb8d-4e94-87ef-ab36e4cc12ae",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Параметры текста, оптимальные для чтения"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0f093014-6b62-4b6a-b88e-93448d8dc9f3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "55cc1bf5-f7c5-4762-ac5f-074461df4632",
			"type": "column_list",
			"content": [
				"a71c0117-b6c2-4a28-a3cc-45d942dc61ca",
				"cb81d830-3a2e-47ec-8e6e-800c43ca9576"
			],
			"format": {
				"copied_from_pointer": {
					"id": "82bf568a-8e3b-4df2-b93b-4083f6a44315",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "18c8a3e6-6288-4a41-9714-387d3d08882f",
			"type": "column_list",
			"content": [
				"a6a3e62c-b799-4c16-87e9-2a78bdd77f10",
				"a07cfc39-b184-40a4-899f-7a6d95c2645f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "87d2945c-32fa-4015-8428-304e58fc44cf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7a6fcfcb-1a2d-452f-a31c-ab6f5e2ae021",
			"type": "column_list",
			"content": [
				"746361f0-b6d6-436d-abd8-01c74ffc95b6",
				"d60a0302-fc06-490c-af0d-e3dc71f1a81e"
			],
			"format": {
				"copied_from_pointer": {
					"id": "6422a6e0-f101-4ba7-bd58-1090c0e50f51",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "83bc4b03-2659-4831-937b-865e045ae664",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://material.io/design/color/text-legibility.html#legibility-standards"
					]
				],
				"title": [
					[
						"Material Design"
					]
				],
				"caption": [
					[
						"Material Design о доступности текста"
					]
				],
				"description": [
					[
						"Build beautiful, usable products faster. Material Design is an adaptable system-backed by open-source code-that helps teams build high quality digital experiences."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://material.io/static/assets/favicon.ico",
				"copied_from_pointer": {
					"id": "9bfac740-9069-4ed7-bb7d-5c836b4b2526",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "310bd1af-ec4b-4816-bf67-1eb88622abf1",
			"type": "header",
			"properties": {
				"title": [
					[
						"Цвет"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c23e7f75-0d21-4705-8a98-ac3c8811649b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "428a2e41-1587-4604-85d0-3aca0735b0c3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Рекомендации, приведённые в этом разделе, не применяются для промоматериалов и внешней коммуникации продуктов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9c39773d-8b49-46fa-81bb-3caf14cd4573",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d6761429-81a3-4a99-b5ee-d29eed8390bb",
			"type": "column_list",
			"content": [
				"b3e576aa-705b-4933-84ea-2eb9087a6ff7",
				"22dff27f-4817-42ad-a270-8ae1877978b6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "afd0363f-b90b-4597-921f-96e3bd9587f9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "25bcc38a-d74c-4034-a3b7-b9237c2e7fdb",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Обращайте внимание на считываемость цветов и контрастов в ваших макетах, а также тестируйте их для людей с особенностями зрения."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "b6434188-094a-4c75-8556-794f8d0cf306",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a2888952-14e9-476a-ba64-1e4ad7779a16",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Допустимая контрастность для цветовых пар и сочетаний"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a41558ca-896c-4f7a-acbc-92d556587f87",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "05b9f6d0-37e4-4d14-abc2-b2301f55b96c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Допустимая контрастность рассчитывается по формуле коэффициента контрастности стандарта WCAG: "
					],
					[
						"(L1 + 0,05) / (L2 + 0,05)",
						[
							[
								"b"
							]
						]
					],
					[
						", в которой "
					],
					[
						"L1",
						[
							[
								"b"
							]
						]
					],
					[
						" — относительная яркость самого светлого цвета, "
					],
					[
						"L2",
						[
							[
								"b"
							]
						]
					],
					[
						" — относительная яркость самого тёмного цвета."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "441d4f13-fa52-47ff-b38c-c4ae84fa665f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d30dc4f-a467-4103-b329-2793a6df1c5d",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5e978750-6a4d-40d5-b49b-ce9e210c4b6b/contrast_table.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5e978750-6a4d-40d5-b49b-ce9e210c4b6b/contrast_table.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"copied_from_pointer": {
					"id": "053e37d0-f441-43a0-8cc8-73455bff1af3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"file_ids": [
				"5e978750-6a4d-40d5-b49b-ce9e210c4b6b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3d30dc4f-a467-4103-b329-2793a6df1c5d.png"
		},
		{
			"id": "a41b8223-82a1-4fa5-be10-5eba8a22df32",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef"
					]
				],
				"title": [
					[
						"Web Content Accessibility Guidelines (WCAG) 2.0"
					]
				],
				"description": [
					[
						"This section is normative. abbreviation shortened form of a word, phrase, or name where the abbreviation has not become part of the language Note 1: This includes initialisms and acronyms where: initialisms are shortened forms of a name or phrase made from the initial letters of words or syllables contained in that name or phrase Note 1: Not defined in all languages."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.w3.org/favicon.ico",
				"copied_from_pointer": {
					"id": "75ba665c-5b38-4df3-820e-1db68216cf5f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bec61e00-f2fd-4589-a965-1fed727820f8",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Рекомендации по контрастности для мобильных устройств"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "87cfc4b9-573e-4d8d-bcf2-eb56c40a67ff",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2a87b7dd-f5b5-4f16-867b-d772afb4d3ac",
			"type": "text",
			"properties": {
				"title": [
					[
						"Устройства с высокими значениями матрицы позволяют более свободно относиться к коэффициенту контраста. Однако не стоит исключать воздействие внешней среды:  попадание прямого света, высокий уровень информационного шума и т.п."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f278a789-8501-4cef-aefa-1923a69cd67f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1b96918c-9284-4767-a862-4432a01aef9d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Проверяя контрастность на мобильном устройстве, учитывайте параметры матрицы популярных устройств, а не только коэффициент контрастности."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dde1bd2f-89b4-42bc-a2fe-c0fd083bff93",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1a494066-e050-4086-90e8-3a8d3a0cfab1",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.w3.org/TR/WCAG21/#visual-presentation"
					]
				],
				"title": [
					[
						"Web Content Accessibility Guidelines (WCAG) 2.1"
					]
				],
				"description": [
					[
						"Web Content Accessibility Guidelines (WCAG) 2.1 covers a wide range of recommendations for making Web content more accessible. Following these guidelines will make content more accessible to a wider range of people with disabilities, including accommodations for blindness and low vision, deafness and hearing loss, limited movement, speech disabilities, photosensitivity, and combinations of these, and some accommodation for learning disabilities and cognitive limitations; but will not address every user need for people with these disabilities."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.w3.org/favicon.ico",
				"copied_from_pointer": {
					"id": "4c69e979-ab55-4ea1-8307-f9c21d92df4b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "065b8a26-355b-462f-b90b-23e395671368",
			"type": "header",
			"properties": {
				"title": [
					[
						"Графика"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f0f70fa7-2b8c-46ce-b971-6078b4dec272",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "539c2adf-4da3-44c5-be93-2ee7a4696aa0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пользователь должен понимать контент, включающий графики, иконки и изображения. Не полагайтесь только на графику в пояснении контента: она должна создавать настроение и дополнять повествование, а не заменять его."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e526f729-3efd-49ad-97d7-972e8a8763bc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "612404d5-c308-4f87-a781-e2254813dd80",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Используйте иконки как дополнительные визуальные подсказки, а не как декор"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dcb4668f-4c88-4ca2-ace9-9b78b5110eea",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e241594-59da-4a83-87a6-83337df79b99",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"При наложении текста на картинку помните о контрастности"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f4f82225-3961-4d5f-8fce-8ac233f33e5c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4a8dc47b-c220-41ec-bbe1-1f01c01ac7ea",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Убедитесь, что вся графика сопровождается кратким и понятным описанием"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b57d4296-a703-41d1-af12-3bb9e3921d91",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fc1cb1ec-355c-44ba-9806-4e9c285ab16a",
			"type": "header",
			"properties": {
				"title": [
					[
						"Интерактивные области"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aa7f0325-3bb5-41c6-b2ce-4c2591c98a48",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bf3b4f54-6413-4d50-ac2e-916e477ba8c5",
			"type": "text",
			"properties": {
				"title": [
					[
						"На тач-устройствах область нажатия должна быть достаточно большой и доступной. Особенно внимательно отнеситесь к работе с областью нажатия на устройствах с крупным экраном."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "63e47d84-8a1b-4b46-b885-fb69aef25aac",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6fa063ff-a7a3-48a8-84d9-4d56088075f2",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Убедитесь, что до основных контролов можно дотянуться большими пальцами и левой, и правой руки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e02ce72f-1d6b-4c38-8ad3-d067ad1b0a6e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9341e0da-b13c-45ad-968a-c7a9a7bba9db",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Следите за размером области нажатия: размер подушечки пальца порядка 10 мм. Ориентируйтесь на эту величину"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "db420796-c04e-4162-992c-cdd2f3f15e1f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7034aece-d906-4644-ac9c-52c0df5dfd4e",
			"type": "header",
			"properties": {
				"title": [
					[
						"Текст"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aeaf7706-1ec7-4343-bbe3-3213f9fb955d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c21d76e8-eeb9-43f3-880e-c93fc05a832a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Визуальная архитектура в дизайне неразрывно связана с текстом. Если вы не уверены в тексте, привлеките копирайтера."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5c623ce2-ba64-4302-a1f2-60eebde8912c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb4ba2b7-07fd-4d7d-ad4b-6b0182aaee88",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Подписи элементов должны объяснять, что произойдет при нажатии"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "da9b2c6f-33d3-49e7-819c-2cf948a451b5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "054334c3-f707-4697-91b1-ccd69e1dbe42",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Если клик приведет к скачиванию документа, напишите об этом прямо. Это важно для пользователей мобильных устройств, у которых может быть ограничен трафик"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8115d42b-477a-41d0-82f4-a71420e30729",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b301a268-c1f3-40c9-a600-99098448dc65",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"Не делайте отсылок к форме, размеру, визуальному расположению или звуку — не все могут их воспринимать"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "385000d0-e6ad-4bfa-bef0-2f657f6681ea",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9947a597-aa97-4586-9c57-2db989552727",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "ac3c9fb7-da6c-493b-80f6-9b8765234588",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7f75bf12-4e37-4965-952b-fa99538fe887",
			"type": "sub_header",
			"properties": {
				"title": [
					[
						"Не забывайте о вспомогательных технологиях"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "691612fd-799b-42e6-84e0-1b4a0dcb6600",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "37e3810e-16cb-43d1-8f3a-c4637e02a4fe",
			"type": "text",
			"properties": {
				"title": [
					[
						"Вспомогательные технологии — это технические средства для облегчения быта жизни людей с инвалидностью."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d7c94545-d44a-4769-bfbd-44b8f1190388",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "74f1b084-a764-44ab-8138-1e067326ab52",
			"type": "column_list",
			"content": [
				"f6a4b374-8430-47f1-abef-ce70f4e16a66",
				"9e5400d5-ea06-4b5e-be5d-e1df22835ea5"
			],
			"format": {
				"copied_from_pointer": {
					"id": "f93750a4-3637-47ad-80d1-be076927b9dc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "80c028b6-7572-4b76-8cdd-8c28d5bed509",
			"type": "header",
			"properties": {
				"title": [
					[
						"Как поддерживать баланс"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0e8b8665-311b-4af9-82b1-0fc79dcad59a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ef6e9d3b-36d8-4d0e-aeb6-3216bed283b1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Чтобы сделать дизайн ваших интерфейсов доступнее, изучайте графический дизайн. Большинство приёмов и правил графического дизайна основаны на том, чтобы дизайн был доступен большому числу людей."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "49618608-38a9-42c7-81a2-cf648a2f61a7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3d57d1c-e525-40d0-8b84-b7a25c55df90",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Одно исследование лучше, чем десяток правил. Исследуйте ваши продукты на доступность."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9eee2d57-ebf1-4e35-af2c-34a1a7aa3b85",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "44183c3a-4c0b-4f67-98c7-ab2c3e451be2",
			"type": "header",
			"properties": {
				"title": [
					[
						"Полезные ссылки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9e665fbd-37f6-4798-9b90-618e8ab28438",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6d3a5461-5080-4946-a567-e57cc0111e89",
			"type": "column_list",
			"content": [
				"0d851943-9ea2-4cce-9ede-fb4e1c71559c",
				"4106ef2a-0794-4f20-ac1c-012ab69eb2a4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "8c23bbfe-66d9-403a-b41e-c9f9aa6e8923",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2d4c84c1-1365-42bb-8f3e-3a1e0851210d",
			"type": "column_list",
			"content": [
				"6cea2f4b-7f8a-48e5-9b9d-e1f3cd5e8f32",
				"8f21512e-c0bc-4b15-9dd9-ed96d2a6f693"
			],
			"format": {
				"copied_from_pointer": {
					"id": "33fa152f-84c9-4580-ad1c-af16dc5100d2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0be31fb9-1412-47e4-8f0f-e14dfa254038",
			"type": "column_list",
			"content": [
				"11c87863-0c64-403e-9b69-0678a6b8dc67",
				"829f853e-832c-4a78-aab6-d05e620d51c6"
			],
			"format": {
				"copied_from_pointer": {
					"id": "956de0d9-6e2c-4a26-b261-7e4fa507852c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "abe4e7bc-db74-4257-a6fb-7e96d64743d5",
			"type": "header",
			"properties": {
				"title": [
					[
						"Инструменты для дизайнера"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e09947fa-8a71-42a3-a84e-2a93ea53351a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa752c8a-4141-4d70-9db3-aeeb5e102ed4",
			"type": "column_list",
			"content": [
				"5493449e-0760-4aa8-8d2c-dd36af318bd3",
				"899c4851-87d2-4674-b0bb-4e6f4e3f55ff"
			],
			"format": {
				"copied_from_pointer": {
					"id": "fa0bb9e8-d264-4f36-9683-89c6e8b72bee",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "acdb9319-182d-4fb0-ab04-42ae3c809560",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "d44b9fcb-42ca-4968-8a5c-188ffd6d9436",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7c3ac514-3a4a-4daa-b557-be77f7a6ee09",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "866804b8-e8a9-4dab-987c-3ac6f7e1206f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e018c766-349f-4983-8bec-33859a82ec06",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "8ddaa41b-adf1-4238-8fd1-a4d029449acb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "28b470cc-d5dc-4bac-b2e9-42184e6a9aa1",
			"type": "column",
			"content": [
				"d131bd0b-6b9c-4961-ba32-15f498db5232",
				"b5af9f06-39e7-4b51-bb84-4898293efba4"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "aefdbb01-80fc-4268-9d66-cffa5f1877c7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7cdc7a1f-07b7-4091-8145-ecf29e2bd537",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "99b6c441-6885-427b-abbc-4311488a29df",
			"type": "column",
			"content": [
				"a5d7728f-ce31-49e1-b591-6448ccf8c9ae",
				"c42ec84c-381f-4781-8011-12f180f68eff"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "1f1ce236-60b2-48da-a5fa-7585250890f3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7cdc7a1f-07b7-4091-8145-ecf29e2bd537",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d131bd0b-6b9c-4961-ba32-15f498db5232",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Структура"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dbc45828-6011-4b0b-b7e0-7be06b34a35e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "28b470cc-d5dc-4bac-b2e9-42184e6a9aa1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5af9f06-39e7-4b51-bb84-4898293efba4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Легко понять структуру страницы, смысл и что можно на ней сделать"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b5becb35-8511-433c-84ba-0c455a47a6e1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "28b470cc-d5dc-4bac-b2e9-42184e6a9aa1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a5d7728f-ce31-49e1-b591-6448ccf8c9ae",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Типографика"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3e305731-b486-4852-91ae-643b4470f4a5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "99b6c441-6885-427b-abbc-4311488a29df",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c42ec84c-381f-4781-8011-12f180f68eff",
			"type": "text",
			"properties": {
				"title": [
					[
						"Текст легко и удобно читать"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "44884d32-c313-442c-a222-a13a83ffaab5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "99b6c441-6885-427b-abbc-4311488a29df",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9e29d934-7a04-4bdd-a929-d5767e33e97d",
			"type": "column",
			"content": [
				"7db403ae-36da-4d9f-87df-c752ca1ce6e5",
				"ce56c76f-dd39-40af-8d04-757253c64bf2"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "cb24857e-64ec-42ce-a443-00f02563bb04",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0eff6331-5eb8-4cfb-8cf0-f08aab3f7b98",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dba69699-f352-490d-b6da-a8d51b4b9a79",
			"type": "column",
			"content": [
				"02c4aaf7-308e-4c11-a96a-b63248e8148d",
				"620390fe-66f5-4baa-99b5-ec8774dc41b8"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "544c8fcd-62d2-4a56-8e5b-92c47f01eeee",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0eff6331-5eb8-4cfb-8cf0-f08aab3f7b98",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7db403ae-36da-4d9f-87df-c752ca1ce6e5",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Цвет"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "06fa03e1-d8ce-4825-b8b6-42cbe77de19e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9e29d934-7a04-4bdd-a929-d5767e33e97d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce56c76f-dd39-40af-8d04-757253c64bf2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Можно различить элементы, их функции и состояния"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "22117046-45b0-41bd-8d4c-6bf99861a716",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9e29d934-7a04-4bdd-a929-d5767e33e97d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "02c4aaf7-308e-4c11-a96a-b63248e8148d",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Графика"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e385763b-b0f8-47f0-b95a-b030d1c6794f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "dba69699-f352-490d-b6da-a8d51b4b9a79",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "620390fe-66f5-4baa-99b5-ec8774dc41b8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Понятны метафоры, дополняющие смысл контента"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1d856ba8-6b9f-4fe7-b837-28a42f6d283d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "dba69699-f352-490d-b6da-a8d51b4b9a79",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a80796c5-7063-4e85-a192-c99ae1415d1a",
			"type": "column",
			"content": [
				"58cf0348-925a-428d-8fde-48ffb8ce80f5",
				"6bc70cf3-2e80-4235-9eb3-722012638d1c"
			],
			"format": {
				"column_ratio": 0.5000000000000001,
				"copied_from_pointer": {
					"id": "4f8ba9f4-1ded-4ab0-94eb-011e28ce11dd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6056fae5-263a-491e-a408-9cc5f9550953",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9a798378-9f34-4cc6-967e-0e683897288c",
			"type": "column",
			"content": [
				"9fb0682a-2bef-4bc5-8c98-d39142b608e1",
				"95d4501d-5ae3-43a0-8472-5973430f31bd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "9ac2426c-68b1-4de0-aaf6-aa81e6f5b051",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6056fae5-263a-491e-a408-9cc5f9550953",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58cf0348-925a-428d-8fde-48ffb8ce80f5",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Интерактивные области"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e220b8cc-0de8-473a-81bc-a342338921bc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a80796c5-7063-4e85-a192-c99ae1415d1a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6bc70cf3-2e80-4235-9eb3-722012638d1c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Не затруднено взаимодействие с кликабельными областями "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8cb78759-f113-42f0-a344-3ebc58ac40ed",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a80796c5-7063-4e85-a192-c99ae1415d1a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9fb0682a-2bef-4bc5-8c98-d39142b608e1",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Текст"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2ee8092f-c958-4ef1-96a6-55f4701c054b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a798378-9f34-4cc6-967e-0e683897288c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "95d4501d-5ae3-43a0-8472-5973430f31bd",
			"type": "text",
			"properties": {
				"title": [
					[
						"Понятен смысл текста"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1531b631-1589-4682-a58d-b8074e4bd8d8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a798378-9f34-4cc6-967e-0e683897288c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5b79f2f6-02da-4cbd-b826-a9e21dff7b79",
			"type": "column",
			"content": [
				"4ff22581-22e3-49d2-a07e-aea1b48c38e0",
				"8a7db26c-dac7-4924-80fa-4c1a1afdaf4a"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "30e1ef9c-7a96-4030-b81a-eecc0651c000",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "fdb5d247-c8b6-48cd-83e5-9e4b0ab7edeb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "48c55243-df9a-4ec9-ab43-840955a377df",
			"type": "column",
			"content": [
				"ad21dc1b-f399-48d3-ba01-114fb9b02fc6",
				"eebf4cd9-5dfc-4dde-a8b1-4f45c9893d7c"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "abfde7ac-2403-4147-bf33-65510c862a6c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "fdb5d247-c8b6-48cd-83e5-9e4b0ab7edeb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4ff22581-22e3-49d2-a07e-aea1b48c38e0",
			"type": "image",
			"properties": {
				"size": [
					[
						"144.8KB"
					]
				],
				"title": [
					[
						"1.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f9ac005f-bf8a-4a78-b47e-e43651898a02/1.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f9ac005f-bf8a-4a78-b47e-e43651898a02/1.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.529,
				"block_preserve_scale": true
			},
			"parent_id": "5b79f2f6-02da-4cbd-b826-a9e21dff7b79",
			"parent_table": "block",
			"file_ids": [
				"f9ac005f-bf8a-4a78-b47e-e43651898a02"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4ff22581-22e3-49d2-a07e-aea1b48c38e0.png"
		},
		{
			"id": "8a7db26c-dac7-4924-80fa-4c1a1afdaf4a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Обратите внимание на стили: заголовки первого уровня на макете должны быть заголовками "
					],
					[
						"h1",
						[
							[
								"b"
							]
						]
					],
					[
						" в коде — так сохранится корректная структура считывания"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ba00e9d9-9220-4bc7-9243-9892dfef702d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5b79f2f6-02da-4cbd-b826-a9e21dff7b79",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ad21dc1b-f399-48d3-ba01-114fb9b02fc6",
			"type": "image",
			"properties": {
				"size": [
					[
						"189.6KB"
					]
				],
				"title": [
					[
						"2.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3e97a772-54e1-4368-bee6-ca1147de7332/2.png"
					]
				]
			},
			"format": {
				"block_width": 331,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3e97a772-54e1-4368-bee6-ca1147de7332/2.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.529,
				"block_preserve_scale": true
			},
			"parent_id": "48c55243-df9a-4ec9-ab43-840955a377df",
			"parent_table": "block",
			"file_ids": [
				"3e97a772-54e1-4368-bee6-ca1147de7332"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ad21dc1b-f399-48d3-ba01-114fb9b02fc6.png"
		},
		{
			"id": "eebf4cd9-5dfc-4dde-a8b1-4f45c9893d7c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Скринридер плохо работает с всплывающими объектами и модальными окнами"
					]
				]
			},
			"content": [
				"02664fad-02d9-4aea-9242-de1a49cda3e7"
			],
			"format": {
				"copied_from_pointer": {
					"id": "5ef93845-77cd-4d9f-aac7-5350bbe09295",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "48c55243-df9a-4ec9-ab43-840955a377df",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "02664fad-02d9-4aea-9242-de1a49cda3e7",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "6baa78d9-cca9-49ad-a7e3-040cb49d3438",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "eebf4cd9-5dfc-4dde-a8b1-4f45c9893d7c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a71c0117-b6c2-4a28-a3cc-45d942dc61ca",
			"type": "column",
			"content": [
				"b7be81a6-a798-4189-83c6-905780737db7",
				"b3501e34-6a05-4fa0-b252-90afb8ce3e92"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "3d7f7ddd-7668-4ba3-8736-05bb922579cf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "55cc1bf5-f7c5-4762-ac5f-074461df4632",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb81d830-3a2e-47ec-8e6e-800c43ca9576",
			"type": "column",
			"content": [
				"ebd0e5b6-7ba5-4edc-8807-f5463e977aca",
				"1ff52605-c8c1-44dd-8f7e-b4ec27e873ee"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "6d3ad29b-c1c1-443e-a0bf-a18092fa59f5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "55cc1bf5-f7c5-4762-ac5f-074461df4632",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b7be81a6-a798-4189-83c6-905780737db7",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8becbe16-70aa-45ae-b04a-b24470645bdd/font_size.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8becbe16-70aa-45ae-b04a-b24470645bdd/font_size.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "67479261-7599-4997-9204-d8c0d6207b92",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "a71c0117-b6c2-4a28-a3cc-45d942dc61ca",
			"parent_table": "block",
			"file_ids": [
				"8becbe16-70aa-45ae-b04a-b24470645bdd"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b7be81a6-a798-4189-83c6-905780737db7.png"
		},
		{
			"id": "b3501e34-6a05-4fa0-b252-90afb8ce3e92",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используйте комфортный для чтения размер шрифта: для основного текста минимум "
					],
					[
						"16px",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e81bdee0-ea31-42c6-80e4-9355469de5eb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a71c0117-b6c2-4a28-a3cc-45d942dc61ca",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ebd0e5b6-7ba5-4edc-8807-f5463e977aca",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a5f66117-3bfa-4771-bcbd-c7367d58690c/font_size-1.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a5f66117-3bfa-4771-bcbd-c7367d58690c/font_size-1.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "3d94ea62-5402-4a1f-acc3-d08e24994fcc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "cb81d830-3a2e-47ec-8e6e-800c43ca9576",
			"parent_table": "block",
			"file_ids": [
				"a5f66117-3bfa-4771-bcbd-c7367d58690c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ebd0e5b6-7ba5-4edc-8807-f5463e977aca.png"
		},
		{
			"id": "1ff52605-c8c1-44dd-8f7e-b4ec27e873ee",
			"type": "text",
			"properties": {
				"title": [
					[
						"Длина строки для комфортного чтения: приемлемое количество символов — "
					],
					[
						"45 – 75",
						[
							[
								"b"
							]
						]
					],
					[
						", оптимальное — "
					],
					[
						"66",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0a87e15d-f972-45d6-a04a-5f78324f8967",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "cb81d830-3a2e-47ec-8e6e-800c43ca9576",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a6a3e62c-b799-4c16-87e9-2a78bdd77f10",
			"type": "column",
			"content": [
				"5b992d7c-ebd6-4443-a972-81238dcc1bf5",
				"144eea02-2b6f-4053-b652-31773a5f051d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "ed417155-2877-462e-bd85-64062f4de8db",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "18c8a3e6-6288-4a41-9714-387d3d08882f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a07cfc39-b184-40a4-899f-7a6d95c2645f",
			"type": "column",
			"content": [
				"d1e9bcc1-4491-498d-b328-638f77f4728b",
				"06b49f9b-1da7-4511-a0fc-0797b249e57f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "61999470-e5f5-4d35-af22-0fbe6c777d47",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "18c8a3e6-6288-4a41-9714-387d3d08882f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5b992d7c-ebd6-4443-a972-81238dcc1bf5",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d006c56b-9dbe-467d-81b4-7c1abbbd6320/lineheight_title.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d006c56b-9dbe-467d-81b4-7c1abbbd6320/lineheight_title.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "ed517b0d-183c-49d8-b57c-5bff904ce706",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "a6a3e62c-b799-4c16-87e9-2a78bdd77f10",
			"parent_table": "block",
			"file_ids": [
				"d006c56b-9dbe-467d-81b4-7c1abbbd6320"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5b992d7c-ebd6-4443-a972-81238dcc1bf5.png"
		},
		{
			"id": "144eea02-2b6f-4053-b652-31773a5f051d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Комфортное соотношение межстрочного расстояния к кеглю для заголовков: "
					],
					[
						"1 – 1,3",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e45c613d-188b-4ab1-88f6-dccb16b5edb2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a6a3e62c-b799-4c16-87e9-2a78bdd77f10",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1e9bcc1-4491-498d-b328-638f77f4728b",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/440f9065-0bb7-44d5-b3c5-60ef3c6507f0/lineheight_text.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/440f9065-0bb7-44d5-b3c5-60ef3c6507f0/lineheight_text.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "19ed3f24-cc4e-47f3-baa4-8f0404412ae9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "a07cfc39-b184-40a4-899f-7a6d95c2645f",
			"parent_table": "block",
			"file_ids": [
				"440f9065-0bb7-44d5-b3c5-60ef3c6507f0"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d1e9bcc1-4491-498d-b328-638f77f4728b.png"
		},
		{
			"id": "06b49f9b-1da7-4511-a0fc-0797b249e57f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Комфортное соотношение межстрочного расстояния к кеглю для текста: "
					],
					[
						"1,4 – 1,65",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "79853921-2f98-4725-8cea-82f26c5b3aa5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a07cfc39-b184-40a4-899f-7a6d95c2645f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "746361f0-b6d6-436d-abd8-01c74ffc95b6",
			"type": "column",
			"content": [
				"e7e5813a-4913-40f8-9960-dcc68dec3de6",
				"c22cd3c8-1b8e-4424-b0ac-0e7ccd741ac7"
			],
			"format": {
				"column_ratio": 0.5000000000000001,
				"copied_from_pointer": {
					"id": "fa3cb344-f9b3-4da4-a38b-502855b1096b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7a6fcfcb-1a2d-452f-a31c-ab6f5e2ae021",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d60a0302-fc06-490c-af0d-e3dc71f1a81e",
			"type": "column",
			"content": [
				"2a91efa9-2f4b-4e08-8445-66fd1af9af66",
				"22f9587c-442c-4c26-bdc8-a9c3dafee1a6"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "4e1b6466-e559-4694-a919-0641981b9df2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7a6fcfcb-1a2d-452f-a31c-ab6f5e2ae021",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e7e5813a-4913-40f8-9960-dcc68dec3de6",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/53746b84-87c5-4c08-bd06-290aa557a9b8/paragraph.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/53746b84-87c5-4c08-bd06-290aa557a9b8/paragraph.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "d905b23b-856c-464c-945a-ab73ca9fa386",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "746361f0-b6d6-436d-abd8-01c74ffc95b6",
			"parent_table": "block",
			"file_ids": [
				"53746b84-87c5-4c08-bd06-290aa557a9b8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e7e5813a-4913-40f8-9960-dcc68dec3de6.png"
		},
		{
			"id": "c22cd3c8-1b8e-4424-b0ac-0e7ccd741ac7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интервал между следующими абзацами рекомендуется делать не менее чем "
					],
					[
						"в 2 раза",
						[
							[
								"b"
							]
						]
					],
					[
						" превышающим размер шрифта"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "388fddf5-513b-4d7d-b482-4693d4860842",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "746361f0-b6d6-436d-abd8-01c74ffc95b6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2a91efa9-2f4b-4e08-8445-66fd1af9af66",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/868c557f-125c-4c87-aecb-389c8d65463e/spacing.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/868c557f-125c-4c87-aecb-389c8d65463e/spacing.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "104b57d4-cbf5-44e5-9c4f-c590f85557b3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "d60a0302-fc06-490c-af0d-e3dc71f1a81e",
			"parent_table": "block",
			"file_ids": [
				"868c557f-125c-4c87-aecb-389c8d65463e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2a91efa9-2f4b-4e08-8445-66fd1af9af66.png"
		},
		{
			"id": "22f9587c-442c-4c26-bdc8-a9c3dafee1a6",
			"type": "text",
			"properties": {
				"title": [
					[
						"Интервал между буквами должен быть не менее "
					],
					[
						"0,12 раза",
						[
							[
								"b"
							]
						]
					],
					[
						" больше размера шрифта"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5d3d2dbd-4ffc-4914-9ac9-dd952f9032e6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "d60a0302-fc06-490c-af0d-e3dc71f1a81e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b3e576aa-705b-4933-84ea-2eb9087a6ff7",
			"type": "column",
			"content": [
				"e0ebc6d3-d611-4ac9-b28d-af608b80223e",
				"8836741c-a577-4987-a7b0-5c3147e26a95"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "9c78882b-c3d1-412b-b432-9b87d9d43afe",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "d6761429-81a3-4a99-b5ee-d29eed8390bb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "22dff27f-4817-42ad-a270-8ae1877978b6",
			"type": "column",
			"content": [
				"8a44b366-b37d-40ff-a9ed-23a04325c81a",
				"cb1da380-c57d-4780-a994-ec9eccc5f328"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "770d45c9-c952-4b5d-ab8a-3664d1f4dfbf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "d6761429-81a3-4a99-b5ee-d29eed8390bb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e0ebc6d3-d611-4ac9-b28d-af608b80223e",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/558524f4-79c6-4269-b8e0-8ac15d011e8d/contrast.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/558524f4-79c6-4269-b8e0-8ac15d011e8d/contrast.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "3da2c714-2c3b-4f02-8abe-f9b46ca6e4a2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "b3e576aa-705b-4933-84ea-2eb9087a6ff7",
			"parent_table": "block",
			"file_ids": [
				"558524f4-79c6-4269-b8e0-8ac15d011e8d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e0ebc6d3-d611-4ac9-b28d-af608b80223e.png"
		},
		{
			"id": "8836741c-a577-4987-a7b0-5c3147e26a95",
			"type": "text",
			"properties": {
				"title": [
					[
						"Убедитесь, что контраст между цветом текста и фоном достаточен"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c95211d7-7754-4bb4-9729-61965777416a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "b3e576aa-705b-4933-84ea-2eb9087a6ff7",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8a44b366-b37d-40ff-a9ed-23a04325c81a",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fff0f934-fcda-4bfc-9244-6cb2bc513add/alternatives.png"
					]
				]
			},
			"format": {
				"block_width": 1032,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fff0f934-fcda-4bfc-9244-6cb2bc513add/alternatives.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"copied_from_pointer": {
					"id": "06ff7514-599e-42a9-bda8-99106b98db4c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "22dff27f-4817-42ad-a270-8ae1877978b6",
			"parent_table": "block",
			"file_ids": [
				"fff0f934-fcda-4bfc-9244-6cb2bc513add"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/8a44b366-b37d-40ff-a9ed-23a04325c81a.png"
		},
		{
			"id": "cb1da380-c57d-4780-a994-ec9eccc5f328",
			"type": "text",
			"properties": {
				"title": [
					[
						"Убедитесь, что для информирования или разметки использованы дополнительные способы, помимо цвета"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9c053a17-29f6-4141-8228-eeb8f343125a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "22dff27f-4817-42ad-a270-8ae1877978b6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f6a4b374-8430-47f1-abef-ce70f4e16a66",
			"type": "column",
			"content": [
				"9b92f733-af00-42d9-9f7b-77c9e0fab46d",
				"11fca071-adc7-4f40-80de-9603e57a27a0"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "634ba299-b305-460b-bf4c-b1329ad93437",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "74f1b084-a764-44ab-8138-1e067326ab52",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9e5400d5-ea06-4b5e-be5d-e1df22835ea5",
			"type": "column",
			"content": [
				"8346656f-ab0f-48f3-be9b-1c84bd8db84e",
				"ddc698a6-e9c8-4610-b940-1cd0cc744c7e"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "883113f6-decb-4c0d-bda9-61e64879184d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "74f1b084-a764-44ab-8138-1e067326ab52",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9b92f733-af00-42d9-9f7b-77c9e0fab46d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Скринридер",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fd361663-7182-48ea-8b1e-af99b9059407",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f6a4b374-8430-47f1-abef-ce70f4e16a66",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "11fca071-adc7-4f40-80de-9603e57a27a0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Программа для чтения с экрана компьютера или смартфона, предназначенная для незрячих и людей с ослабленным зрением. Скринридер озвучивает интерфейс, а также создаёт звуковой и виброотклик."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "112003cf-8d8b-4375-9489-1f57d1f07ce2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f6a4b374-8430-47f1-abef-ce70f4e16a66",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8346656f-ab0f-48f3-be9b-1c84bd8db84e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Масштабирование",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a52ad373-b522-48b3-baf3-0982cc232530",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9e5400d5-ea06-4b5e-be5d-e1df22835ea5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ddc698a6-e9c8-4610-b940-1cd0cc744c7e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Масштабирование — стандартный инструмент для слабовидящих. Следите, чтобы при увеличении контента до 200% страница была читаема и функциональна."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d128e0dc-ace3-4985-af87-d2ed5a0d39af",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9e5400d5-ea06-4b5e-be5d-e1df22835ea5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d851943-9ea2-4cce-9ede-fb4e1c71559c",
			"type": "column",
			"content": [
				"d99e1c2c-4da0-4843-b067-24a8056e3687",
				"70c31280-2964-4327-865d-c91379d9d683",
				"e665de10-96f5-4fb0-8f3c-d97c6801e1d9"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "74b1c7a7-19a2-4bc7-8797-ef40fa8538df",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6d3a5461-5080-4946-a567-e57cc0111e89",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4106ef2a-0794-4f20-ac1c-012ab69eb2a4",
			"type": "column",
			"content": [
				"c8fc2523-964d-46ce-83c6-c99323c0c29f",
				"887733a6-2268-4e59-a613-b659ae0ee86c",
				"ae255b1b-66ed-469b-8790-87e88cb64fd1"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "68d01dc8-b6cf-40b8-90bb-9ba74ddc3d11",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6d3a5461-5080-4946-a567-e57cc0111e89",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d99e1c2c-4da0-4843-b067-24a8056e3687",
			"type": "text",
			"properties": {
				"title": [
					[
						"Material Design",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b0e25053-6f2b-490c-acac-cb4d8dd8b89f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0d851943-9ea2-4cce-9ede-fb4e1c71559c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "70c31280-2964-4327-865d-c91379d9d683",
			"type": "text",
			"properties": {
				"title": [
					[
						"Гайдлайны доступности одной из самых крупных дизайн-систем"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f0c6656d-dbf4-42a2-af44-7dcaf4b7e234",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0d851943-9ea2-4cce-9ede-fb4e1c71559c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e665de10-96f5-4fb0-8f3c-d97c6801e1d9",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://material.io/design/usability/accessibility.html#understanding-accessibility"
					]
				],
				"title": [
					[
						"Material Design"
					]
				],
				"description": [
					[
						"Build beautiful, usable products faster. Material Design is an adaptable system-backed by open-source code-that helps teams build high quality digital experiences."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://material.io/static/assets/favicon.ico",
				"copied_from_pointer": {
					"id": "8a11c2ad-7a69-47ae-bb65-3abdadd5e238",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0d851943-9ea2-4cce-9ede-fb4e1c71559c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c8fc2523-964d-46ce-83c6-c99323c0c29f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Microsoft Design",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "72179502-dacc-42d1-93ac-195f45edfbbd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4106ef2a-0794-4f20-ac1c-012ab69eb2a4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "887733a6-2268-4e59-a613-b659ae0ee86c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Инклюзивность в продуктах компании Microsoft"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f557d705-f94b-48f4-bd9f-e4120c706706",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4106ef2a-0794-4f20-ac1c-012ab69eb2a4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ae255b1b-66ed-469b-8790-87e88cb64fd1",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.microsoft.com/design/inclusive/"
					]
				],
				"title": [
					[
						"Microsoft Design"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.microsoft.com/design/icons/favicon.ico",
				"copied_from_pointer": {
					"id": "0597ac56-ae62-4dea-9df2-1436f4eff25d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4106ef2a-0794-4f20-ac1c-012ab69eb2a4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6cea2f4b-7f8a-48e5-9b9d-e1f3cd5e8f32",
			"type": "column",
			"content": [
				"bd5f4fc3-8b93-44c1-b1ee-f2bc68db506a",
				"9ed6a53d-8c15-4112-90d6-e72d26bb4364",
				"27affae0-804f-417f-be61-65f756968738"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "346b778d-34eb-4e45-8d89-f9df69278874",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2d4c84c1-1365-42bb-8f3e-3a1e0851210d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8f21512e-c0bc-4b15-9dd9-ed96d2a6f693",
			"type": "column",
			"content": [
				"35b5d378-ac42-4875-be5b-ec23cabe02ed",
				"67484c7c-2953-444a-a021-59f5697ba6a7",
				"1befbadf-7b6b-439f-b5a3-bd0cf2c69588"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b14ddbd9-192c-47a6-a1a0-78c6e6c45f23",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2d4c84c1-1365-42bb-8f3e-3a1e0851210d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd5f4fc3-8b93-44c1-b1ee-f2bc68db506a",
			"type": "text",
			"properties": {
				"title": [
					[
						"WCAG",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "789ce593-2dd4-46db-a008-3863278613f1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6cea2f4b-7f8a-48e5-9b9d-e1f3cd5e8f32",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9ed6a53d-8c15-4112-90d6-e72d26bb4364",
			"type": "text",
			"properties": {
				"title": [
					[
						"Гайдлайны доступности всех и всего"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "34d50789-0b05-4db4-84b3-e2ac089a0841",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6cea2f4b-7f8a-48e5-9b9d-e1f3cd5e8f32",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "27affae0-804f-417f-be61-65f756968738",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.w3.org/"
					]
				],
				"title": [
					[
						"W3C"
					]
				],
				"description": [
					[
						"Through the year 2020 which has been so difficult for so many, our community has remained a light and an inspiration. With great thanks for all you do and our very best wishes for the new year (see our animated holiday greeting)."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.w3.org/2008/site/images/favicon.ico",
				"bookmark_cover": "https://www.w3.org/2020/12/still.jpg",
				"copied_from_pointer": {
					"id": "d16a9c8b-dfe4-4b76-bd05-67c06f6923fb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6cea2f4b-7f8a-48e5-9b9d-e1f3cd5e8f32",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "35b5d378-ac42-4875-be5b-ec23cabe02ed",
			"type": "text",
			"properties": {
				"title": [
					[
						"Принципы инклюзивности",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "48ed0d3d-c9a7-4186-9807-57205c31840b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8f21512e-c0bc-4b15-9dd9-ed96d2a6f693",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67484c7c-2953-444a-a021-59f5697ba6a7",
			"type": "text",
			"properties": {
				"title": [
					[
						"Принципы инклюзивного дизайна и их подробное описание"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bf62aa62-2185-4740-bd13-5f83737bfbcf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8f21512e-c0bc-4b15-9dd9-ed96d2a6f693",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1befbadf-7b6b-439f-b5a3-bd0cf2c69588",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://inclusivedesignprinciples.org/"
					]
				],
				"title": [
					[
						"Inclusive Design Principles"
					]
				],
				"description": [
					[
						"These Inclusive Design Principles are about putting people first. It's about designing for the needs of people with permanent, temporary, situational, or changing disabilities - all of us really. They are intended to give anyone involved in the design and development of websites and applications - designers, user experience professionals, developers, product owners, idea makers, innovators, artists and thinkers - a broad approach to inclusive design."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://inclusivedesignprinciples.org/favicon.png",
				"copied_from_pointer": {
					"id": "148127a5-7a4c-4852-8abb-5911601b0d02",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8f21512e-c0bc-4b15-9dd9-ed96d2a6f693",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "11c87863-0c64-403e-9b69-0678a6b8dc67",
			"type": "column",
			"content": [
				"855a2212-bc56-45a4-af17-7fddb2766a37",
				"02317c44-2196-4f8c-82d1-6caa938bed36",
				"a8b1e308-f7a8-426b-b83d-7f9e3e800fa0"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "d70c0a49-f54e-4afa-a80e-32a88c07e5b4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0be31fb9-1412-47e4-8f0f-e14dfa254038",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "829f853e-832c-4a78-aab6-d05e620d51c6",
			"type": "column",
			"content": [
				"277802c1-72a0-470c-be1f-e9e3c49efdc5"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "be6ba4b7-7eaf-4533-b6d8-725df4370c42",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0be31fb9-1412-47e4-8f0f-e14dfa254038",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "855a2212-bc56-45a4-af17-7fddb2766a37",
			"type": "text",
			"properties": {
				"title": [
					[
						"Доступность от Сбера",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aa0dbd8e-68f9-4f99-b5c9-594fc0352e25",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "11c87863-0c64-403e-9b69-0678a6b8dc67",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "02317c44-2196-4f8c-82d1-6caa938bed36",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наиболее полное руководство по доступности на русском языке"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f669277b-989d-4a8a-ab55-b524ff56b131",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "11c87863-0c64-403e-9b69-0678a6b8dc67",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a8b1e308-f7a8-426b-b83d-7f9e3e800fa0",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"http://specialbank.ru/guide/index.html"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d149ac70-af0d-4c91-be41-86752b485b8f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "11c87863-0c64-403e-9b69-0678a6b8dc67",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "277802c1-72a0-470c-be1f-e9e3c49efdc5",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "8cb318fa-68fb-408b-b272-f9b173322d6e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "829f853e-832c-4a78-aab6-d05e620d51c6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"type": "column",
			"content": [
				"9854cb3f-e6c8-47dd-9ee6-ee3ecaa5f04a",
				"5e4fab10-ad32-4813-aa9b-a58d846662fb",
				"8e65819f-83e1-4546-8c5c-a0ddf31514d7",
				"8c1a88de-1d6d-408a-9dfd-f793b5cdf706",
				"ac67cba2-962a-41d7-a123-256b06c664e5",
				"9ddedbc1-f650-42b5-b8b2-e74c7a720db2",
				"084dfb0d-cb24-475a-963c-9e0ac43c68c6",
				"e201b35a-e5a6-4436-9ae6-370dc08c1ce6",
				"43c8b5f4-828f-456f-86ab-682192f664b0",
				"1b5524e1-cc6e-4b7e-8795-4456a4f183f9",
				"671e699e-29cc-4ce0-9612-d33580f2137d",
				"61c4661b-1ab7-4ee8-a14a-17373fd8af21"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "8432c5cd-bcad-4987-bd1c-62b63e70fa91",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa752c8a-4141-4d70-9db3-aeeb5e102ed4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"type": "column",
			"content": [
				"ce9e3268-183f-4efb-93a5-f14c3b842cf2",
				"27fb1f53-4439-4f81-84d6-e6a6f66ec81a",
				"ed53829f-f3ed-4ee1-88e3-2912c826c305",
				"c03a08d9-688c-48e5-a213-b9523923234f",
				"c4c58613-37dd-4a1d-86d6-bca6158fe806",
				"4e4a0dc1-a5eb-460e-bb0f-81a48b2b6cf4",
				"0d0666d0-2a5a-4b78-b6b2-9306f3019b9e",
				"d238acc5-a6f8-4157-b03b-07391195f484"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e351b76b-4041-480b-b2e9-828dc545b262",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa752c8a-4141-4d70-9db3-aeeb5e102ed4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9854cb3f-e6c8-47dd-9ee6-ee3ecaa5f04a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Stark",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0ffb5ab0-38d2-45de-a72a-fe49c3e705dd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e4fab10-ad32-4813-aa9b-a58d846662fb",
			"type": "text",
			"properties": {
				"title": [
					[
						"Набор инструментов для проверки доступности"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "59d6596f-2c0d-44df-afff-e19e6e577c5b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8e65819f-83e1-4546-8c5c-a0ddf31514d7",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.getstark.co/"
					]
				],
				"title": [
					[
						"Stark"
					]
				],
				"description": [
					[
						"Contrast Checker Smart Color Suggestions 8 Colorblind Simulations Colorblind Generator Rapid Contrast Checking (Adobe XD) Access to Stark Beta Community All updates and new features Plugins for Figma, Sketch & Adobe XD Unlock Stark Pro everywhere"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.getstark.co/favicons/favicon-16x16.png",
				"bookmark_cover": "https://www.getstark.co/xd-action-1.png",
				"copied_from_pointer": {
					"id": "bb6401a4-d125-471b-b932-2aa512d689cd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8c1a88de-1d6d-408a-9dfd-f793b5cdf706",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "feaab48c-2ea5-48b9-9227-7aa6fff3dd6e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ac67cba2-962a-41d7-a123-256b06c664e5",
			"type": "text",
			"properties": {
				"title": [
					[
						"Colorable",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aa083b76-feae-4f29-b019-98778f982070",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9ddedbc1-f650-42b5-b8b2-e74c7a720db2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Инструмент для проверки контрастности сочетаний цветов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d0b8fcb8-aa17-4392-8dc8-a012c17050b0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "084dfb0d-cb24-475a-963c-9e0ac43c68c6",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://colorable.jxnblk.com/"
					]
				],
				"title": [
					[
						"Colorable"
					]
				],
				"description": [
					[
						"Contrast is the difference in luminance or color that makes an object (or its representation in an image or display) distinguishable. In visual perception of the real world, contrast is determined by the difference in the color and brightness of the object and other objects within the same field of view."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://colorable.jxnblk.com/favicon.png",
				"copied_from_pointer": {
					"id": "39f89960-3444-4a78-a6cd-49f84a4e2c1a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e201b35a-e5a6-4436-9ae6-370dc08c1ce6",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "8ac85c76-d667-450c-85c1-42945cd1e775",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "43c8b5f4-828f-456f-86ab-682192f664b0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Talk Back",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3f24a27d-9eb3-44d2-a444-1df2e4d19c69",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1b5524e1-cc6e-4b7e-8795-4456a4f183f9",
			"type": "text",
			"properties": {
				"title": [
					[
						"Всё о функции Talk Back на Android"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2432b010-9bfd-4faf-b0da-27637a4d276f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "671e699e-29cc-4ce0-9612-d33580f2137d",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://inclusivedesignprinciples.org/"
					]
				],
				"title": [
					[
						"Inclusive Design Principles"
					]
				],
				"description": [
					[
						"These Inclusive Design Principles are about putting people first. It's about designing for the needs of people with permanent, temporary, situational, or changing disabilities - all of us really. They are intended to give anyone involved in the design and development of websites and applications - designers, user experience professionals, developers, product owners, idea makers, innovators, artists and thinkers - a broad approach to inclusive design."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://inclusivedesignprinciples.org/favicon.png",
				"copied_from_pointer": {
					"id": "d7a2505c-b515-4411-8532-774facf89ccf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "61c4661b-1ab7-4ee8-a14a-17373fd8af21",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "c9284ad8-78fe-450b-b2c7-255c999fef4f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5493449e-0760-4aa8-8d2c-dd36af318bd3",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ce9e3268-183f-4efb-93a5-f14c3b842cf2",
			"type": "text",
			"properties": {
				"title": [
					[
						"Сontrast Analyser",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "67388296-cb06-4bb1-9ef9-989a7a5a4427",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "27fb1f53-4439-4f81-84d6-e6a6f66ec81a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Инструмент для проверки контрастности сочетаний цветов"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "127c724b-a962-4137-bd86-0569c51b0119",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ed53829f-f3ed-4ee1-88e3-2912c826c305",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://developer.paciellogroup.com/resources/contrastanalyser/"
					]
				],
				"title": [
					[
						"Colour Contrast Analyser (CCA)"
					]
				],
				"description": [
					[
						"The Colour Contrast Analyser (CCA) helps you determine the legibility of text and the contrast of visual elements, such as graphical controls and visual indicators."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://developer.paciellogroup.com/wp-content/themes/tpg2015/images/icon192x192.png",
				"bookmark_cover": "https://developer.paciellogroup.com/wp-content/uploads/2016/02/icon192x192.png",
				"copied_from_pointer": {
					"id": "5d98694b-2723-49c2-8e2e-ee323e0da67b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c03a08d9-688c-48e5-a213-b9523923234f",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "6e6b693b-47f8-4b72-8feb-1ea38131d20f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c4c58613-37dd-4a1d-86d6-bca6158fe806",
			"type": "text",
			"properties": {
				"title": [
					[
						"Voice Over",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "4244958a-ce90-4cf9-a100-ab2671a2d54e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4e4a0dc1-a5eb-460e-bb0f-81a48b2b6cf4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Всё о функции Voice Over на Mac"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "806265d6-182d-4d19-8841-b2303b8eb538",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d0666d0-2a5a-4b78-b6b2-9306f3019b9e",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://www.apple.com/ru/voiceover/info/guide/_1131.html#vo27992"
					]
				],
				"title": [
					[
						"Приложение A. Команды и жесты"
					]
				],
				"description": [
					[
						"Приведенные ниже команды позволяют включать и выключать VoiceOver, получать справку, изменять основные параметры, а также включать и выключать программы Commander."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.apple.com/favicon.ico",
				"copied_from_pointer": {
					"id": "fc34a046-141f-48a3-92e3-8d2c0fda1c38",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d238acc5-a6f8-4157-b03b-07391195f484",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "11a8c4c1-0a7a-4f40-af66-2f23ee9995a9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "899c4851-87d2-4674-b0bb-4e6f4e3f55ff",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Как проверяются материалы визуального языка",
			"id": "ce637723-b3ac-4ce5-b476-db1dcdff07bf"
		},
		{
			"title": "Структура",
			"id": "575d1f7a-998c-4de7-9556-effab06e85ca"
		},
		{
			"title": "Типографика",
			"id": "fd7aa35a-1860-4801-83d9-11e1c220123f"
		},
		{
			"title": "Цвет",
			"id": "310bd1af-ec4b-4816-bf67-1eb88622abf1"
		},
		{
			"title": "Графика",
			"id": "065b8a26-355b-462f-b90b-23e395671368"
		},
		{
			"title": "Интерактивные области",
			"id": "fc1cb1ec-355c-44ba-9806-4e9c285ab16a"
		},
		{
			"title": "Текст",
			"id": "7034aece-d906-4644-ac9c-52c0df5dfd4e"
		},
		{
			"title": "Как поддерживать баланс",
			"id": "80c028b6-7572-4b76-8cdd-8c28d5bed509"
		},
		{
			"title": "Полезные ссылки",
			"id": "44183c3a-4c0b-4f67-98c7-ab2c3e451be2"
		},
		{
			"title": "Инструменты для дизайнера",
			"id": "abe4e7bc-db74-4257-a6fb-7e96d64743d5"
		}
	]
}} />
);

export default NotionAccessibility;
